var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useContext, useEffect, useState, } from 'react';
import moment from 'moment';
import 'moment-timezone';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '@ally/date-utils';
import { useFormsContext } from '@ally/forms';
import { getAccountId } from '@ally/transfer-account-utils';
import { RemoteStatus } from './Remote';
import { fetchTransferSpeeds, fetchWithdrawalDate, getMinDeliveryDate, selectTransferSpeed, } from './utils';
import { useComputedValues } from './useComputedValues';
import validateDeliveryDate from './fields/DeliveryDate/validator';
import { DELIVERY_DATE_ADVANCE_DAYS, oneTime, SERVER_DATE_FORMAT, SAVE_TRANSFER_ERROR_CODES, } from './constants';
import { useHolidays } from './useHolidays';
var noop = function () {
    /* noop */
};
export var TransferSpeedsContext = createContext({
    transferSpeeds: { status: RemoteStatus.Unloaded },
    setTransferSpeeds: noop,
    selectedSpeed: 'Standard',
    setSelectedSpeed: noop,
    withdrawalDate: { status: RemoteStatus.Unloaded },
    setWithdrawalDate: noop,
});
export var TransferSpeedsProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState({ status: RemoteStatus.Unloaded }), 2), transferSpeeds = _b[0], setTransferSpeeds = _b[1];
    var _c = __read(useState('Standard'), 2), selectedSpeed = _c[0], setSelectedSpeed = _c[1];
    var _d = __read(useState({
        status: RemoteStatus.Unloaded,
    }), 2), withdrawalDate = _d[0], setWithdrawalDate = _d[1];
    return (React.createElement(TransferSpeedsContext.Provider, { value: {
            transferSpeeds: transferSpeeds,
            setTransferSpeeds: setTransferSpeeds,
            selectedSpeed: selectedSpeed,
            setSelectedSpeed: setSelectedSpeed,
            withdrawalDate: withdrawalDate,
            setWithdrawalDate: setWithdrawalDate,
        } }, children));
};
export var useTransferSpeed = function (hostServices) {
    var _a = useContext(TransferSpeedsContext), transferSpeeds = _a.transferSpeeds, setTransferSpeeds = _a.setTransferSpeeds, selectedSpeed = _a.selectedSpeed, setSelectedSpeed = _a.setSelectedSpeed, withdrawalDate = _a.withdrawalDate, setWithdrawalDate = _a.setWithdrawalDate;
    var _b = useComputedValues(), fromAccount = _b.fromAccount, toAccount = _b.toAccount, transferType = _b.transferType, frequency = _b.frequency;
    var holidays = useHolidays();
    // Feature Flags
    var duplicateAccounts = hostServices.featureFlags.variation('FF_payments-duplicate-accounts', true);
    var ndtAsStandard = hostServices.featureFlags.variation('FF_ndt-as-standard', true);
    var deliveryDate = useFormsContext().values.deliveryDate;
    function updateTransferSpeeds(params) {
        return __awaiter(this, void 0, void 0, function () {
            var availableSpeeds, error_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setTransferSpeeds({ status: RemoteStatus.Loading });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchTransferSpeeds(params, hostServices, duplicateAccounts)];
                    case 2:
                        availableSpeeds = _a.sent();
                        setTransferSpeeds({
                            status: RemoteStatus.Loaded,
                            data: availableSpeeds,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        message = SAVE_TRANSFER_ERROR_CODES[error_1.message] ||
                            error_1.errorDescription ||
                            error_1.message;
                        setTransferSpeeds({
                            status: RemoteStatus.Failed,
                            error: new Error(message),
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        if (fromAccount && toAccount && transferType === 'EXTERNAL') {
            updateTransferSpeeds({
                fromAccountId: getAccountId(fromAccount),
                toAccountId: getAccountId(toAccount),
            });
        }
        else {
            setTransferSpeeds({ status: RemoteStatus.Unloaded });
        }
    }, [fromAccount, toAccount]);
    function updateWithdrawalDate(params) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setWithdrawalDate({ status: RemoteStatus.Loading });
                        return [4 /*yield*/, fetchWithdrawalDate(params, hostServices, duplicateAccounts)];
                    case 1:
                        response = _a.sent();
                        setWithdrawalDate({
                            status: RemoteStatus.Loaded,
                            data: moment.tz(response.withdrawalDate, SERVER_DATE_FORMAT, SERVER_TIMEZONE),
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        setWithdrawalDate({
                            status: RemoteStatus.Failed,
                            error: error_2,
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        // Compute Selected Speed
        var newSelectedSpeed = selectTransferSpeed({
            deliveryDate: deliveryDate,
            transferSpeeds: transferSpeeds,
            transferType: transferType,
            frequency: frequency,
        }, ndtAsStandard);
        setSelectedSpeed(newSelectedSpeed);
        // Set withdrawalDate
        if (!deliveryDate || !fromAccount || !toAccount) {
            setWithdrawalDate({ status: RemoteStatus.Unloaded });
            return;
        }
        var minDeliveryDate = getMinDeliveryDate({
            frequency: frequency,
            transferSpeeds: transferSpeeds,
            transferType: transferType,
        });
        var isValidDeliveryDate = validateDeliveryDate(deliveryDate, {
            holidays: holidays,
            minDeliveryDate: minDeliveryDate,
            transferType: transferType,
            maxAdvanceDuration: [DELIVERY_DATE_ADVANCE_DAYS, 'days'],
            frequency: frequency,
        }) === undefined;
        if (!isValidDeliveryDate) {
            setWithdrawalDate({ status: RemoteStatus.Unloaded });
            return;
        }
        if (transferType !== 'EXTERNAL') {
            setWithdrawalDate({
                status: RemoteStatus.Loaded,
                data: moment.tz(deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE),
            });
            return;
        }
        if (transferSpeeds.status !== RemoteStatus.Loaded) {
            setWithdrawalDate({ status: RemoteStatus.Unloaded });
            return;
        }
        var isRecurring = frequency !== oneTime;
        var foundSpeed = transferSpeeds.data.find(function (speed) {
            return (speed.transferSpeed === selectedSpeed &&
                speed.transferfrequency ===
                    (isRecurring ? 'Recurrence' : 'OneTime Transfer'));
        });
        if (foundSpeed &&
            moment
                .tz(deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE)
                .isSame(moment.tz(foundSpeed.deliveryDate, SERVER_DATE_FORMAT, SERVER_TIMEZONE))) {
            setWithdrawalDate({
                status: RemoteStatus.Loaded,
                data: moment.tz(foundSpeed.withdrawalDate, SERVER_DATE_FORMAT, SERVER_TIMEZONE),
            });
            return;
        }
        updateWithdrawalDate({
            fromAccountId: getAccountId(fromAccount),
            toAccountId: getAccountId(toAccount),
            deliveryDate: deliveryDate,
            transferSpeed: newSelectedSpeed,
            frequency: frequency,
        });
    }, [deliveryDate, transferSpeeds, frequency]);
    return {
        transferSpeeds: transferSpeeds,
        selectedSpeed: selectedSpeed,
        withdrawalDate: withdrawalDate,
    };
};
//# sourceMappingURL=useTransferSpeeds.js.map